// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__AiqPn","actions":"GroupTable_actions__3AP97","deleteModalFooter":"GroupTable_deleteModalFooter__1Dfv0"};